import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useResetAccountPasswordState() {
  return useAppState();
}

export function useResetAccountPasswordActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    dispatch((appState) => ({
      ...appState,
      passwordResetTokenId: urlParams.get('password_reset_token_id'),
      passwordResetTokenValue: urlParams.get('password_reset_token_value'),
      resetAccountPasswordForm: {
        password: '',
        passwordConfirmation: '',
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function updateResetAccountPasswordFormPassword(password) {
    dispatch((appState) => ({
      ...appState,
      resetAccountPasswordForm: {
        ...appState.resetAccountPasswordForm,
        password: password,
      },
    }));
  }

  function updateResetAccountPasswordFormPasswordConfirmation(passwordConfirmation) {
    dispatch((appState) => ({
      ...appState,
      resetAccountPasswordForm: {
        ...appState.resetAccountPasswordForm,
        passwordConfirmation: passwordConfirmation,
      },
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: response.feedbackMessage || null,
      feedbackVariant: response.feedbackVariant || null,
    }));
  }

  function onError(feedback) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedback.feedbackMessage || null,
      feedbackVariant: feedback.feedbackVariant || null,
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    updateResetAccountPasswordFormPassword,
    updateResetAccountPasswordFormPasswordConfirmation,
    onResponse,
    onError,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
